import { Breadcrumbs as UiBreadcrumbs, type BreadcrumbsProps } from '@atlas/ui';
import { Link as RouterLink } from 'react-router-dom';

export type { BreadcrumbItem, BreadcrumbsProps } from '@atlas/ui';

/**
 * ATLAS's router-aware {@link UiBreadcrumbs}.
 *
 * The design-system primitive defaults to a plain anchor so it carries no
 * router dependency. Inside the app that default would trigger a full page
 * reload on every crumb, so this wrapper injects React Router's `Link`. Always
 * import breadcrumbs from here (or `@/components/common`) rather than from
 * `@atlas/ui` directly.
 */
export function Breadcrumbs(props: BreadcrumbsProps) {
  return <UiBreadcrumbs linkComponent={RouterLink} {...props} />;
}

export default Breadcrumbs;
